var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1101 3.16598C19.1999 3.80645 20.5765 4.61115 21.1582 4.95601C21.7482 5.30909 22.6085 5.81818 23.0838 6.08915C23.559 6.36833 24.8454 7.12375 25.9516 7.78064L27.959 8.96305L27.9836 12.6088L28 16.2627L25.2059 17.8968C23.6655 18.7918 22.3791 19.539 22.3381 19.5554C22.2972 19.5718 22.2562 17.9543 22.248 15.9589L22.2234 12.3296L19.1098 10.4985L15.9962 8.66745L15.6684 8.8563C15.4881 8.96305 14.1034 9.77595 12.5958 10.6545L9.85085 12.2639L9.80988 15.6962C9.7853 17.5765 9.7853 19.2516 9.80988 19.3994C9.85085 19.6786 9.93278 19.7279 12.7596 21.4029C14.3574 22.339 15.7422 23.1519 15.8323 23.193C15.9716 23.2669 16.4878 22.9877 19.0934 21.4686C20.7895 20.4669 22.207 19.654 22.2398 19.654C22.3627 19.654 27.8361 22.8974 27.8525 22.9795C27.8689 23.0616 27.3691 23.3736 25.2551 24.5971C24.6733 24.9419 22.3545 26.2968 20.1012 27.6106C17.8561 28.9243 16.0044 30 15.988 30C15.9634 30 14.5541 29.1789 12.8416 28.1771L9.72794 26.3625V23.0452C9.72794 21.2305 9.70336 19.7361 9.67878 19.7361C9.6542 19.7361 8.40055 20.4587 6.9011 21.3372C5.39345 22.2158 4.12342 22.9384 4.08245 22.9384C3.98412 22.9384 3.96773 12.1818 4.06606 10.0716L4.11522 8.90557L7.17149 7.09091L10.236 5.28446L13.071 6.95953C14.636 7.87918 15.9224 8.61818 15.9306 8.60997C15.947 8.60176 15.9552 7.11554 15.9552 5.30088C15.9634 3.04282 15.988 2 16.0453 2C16.0945 2 17.0286 2.52552 18.1101 3.16598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/PORTAL.d388e2cc09b1a8f751a0dd2441cda4a8.svg";
export { ForwardRef as ReactComponent };